module.exports = __webpack_public_path__ + "fonts/Ubuntu-Regular.1cbb1b7.ttf";